import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const { L } = useLang();
  return (
    <div className="min-h-[70vh] grid place-items-center bg-[#E8F0FE] px-5" data-testid="payment-cancel-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-10 max-w-md w-full text-center">
        <XCircle className="w-14 h-14 mx-auto text-slate-500" />
        <h1 className="text-2xl font-extrabold mt-4 text-[#0A192F]">{L("Payment cancelled", "भुगतान रद्द")}</h1>
        <p className="text-slate-600 mt-2">{L("No charge was made. Your cart is still saved.", "कोई राशि नहीं कटी। आपका कार्ट सुरक्षित है।")}</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/roboshop"><Button variant="outline" className="rounded-full" data-testid="cancel-shop-btn">{L("Roboshop", "रोबोशॉप")}</Button></Link>
          <Link to="/enroll"><Button className="rounded-full rs-cta" data-testid="cancel-enroll-btn">{L("Enrollment", "दाखिला")}</Button></Link>
        </div>
      </div>
    </div>
  );
}
